import React, { FC, useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useId } from 'react-id-generator';
import { isBrowser } from 'utils/browser';
import extractUrlFromMultiPicker from 'utils/urlMultiPicker';
import IconCustom from 'components/common/IconCustom';
import { IDropdownCategories } from './models';

import './DropdownCategories.scss';

const DropdownCategories: FC<IDropdownCategories> = ({ btn, tags }) => {
  const [categoriesReady, setCategoriesReady] = useState(false);
  const [dropId] = useId();
  const currentPath = isBrowser() ? window.location.pathname : null;
  const matchedTag = tags?.find((tag) => tag.link?.[0]?.url === currentPath);
  const matchedTitle = matchedTag ? matchedTag.title || matchedTag.name : btn;
  const filteredTags = tags.filter((item) => item.name !== matchedTag?.name);

  useEffect(() => setCategoriesReady(true), []);

  return (
    <Dropdown className="dt-dropdown-categories" id={`dt-dropdown-categories-${dropId}`}>
      {filteredTags.length ? (
        <>
          <Dropdown.Toggle variant="primary" size="lg">
            <span>{categoriesReady ? matchedTitle : null}</span>
            <IconCustom icon="next_arrow" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {filteredTags.map(({ id, name, link, title }) => {
              if (!link) {
                return null;
              }

              return (
                <Dropdown.Item key={id} href={extractUrlFromMultiPicker(link)}>
                  {title || name}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </>
      ) : null}
    </Dropdown>
  );
};

export default DropdownCategories;
